import { useMutation } from '@tanstack/react-query';
import { registerNotificationDevice } from '../services/notifications';

/** POST /admin/notifications/register-device */
export const useRegisterNotificationDeviceMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async (payload) => {
      const result = await registerNotificationDevice(payload);
      if (!result.success) {
        throw new Error(result.message || 'Failed to register device for notifications');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
